import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { advancedOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { UnmappedProduct } from '../../../../store/ProductMap';

interface UnmappedProductGridColumnDefsProps {
  openModal?: (product: UnmappedProduct) => void;
}

export const DefaultUnmappedProductGridColumnDefs = ({
  openModal = undefined
}: UnmappedProductGridColumnDefsProps): GridSingleSelectColDef[] => [
  {
    headerName: 'RPM Product',
    field: 'rpmProductName',
    flex: 2,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<UnmappedProduct>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Product.aspx?Item=${params.row.rpmProductId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.rpmProductName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'RPM Supplier',
    field: 'rpmProductSupplierName',
    flex: 1,
    minWidth: 150,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<UnmappedProduct>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Supplier.aspx?Item=${params.row.rpmProductSupplierId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.rpmProductSupplierName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'latestRunItems',
    headerName: 'Latest Run Items',
    sortable: false,
    filterable: false,
    flex: 1,
    type: 'singleSelect',
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams<UnmappedProduct>) => (
      <a
        className="text-indigo"
        title="View in RPM"
        // eslint-disable-next-line max-len
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/CommItems.aspx?ViewID=32&Specific=${params.row.rpmProductId}&YM=${params.row.latestRunYearMonth}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          View in RPM
          <Icon type="external" />
        </div>
      </a>
    ),
    description: 'Drag to move column'
  },
  {
    field: 'rpmProductId',
    headerName: 'RPM ID',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    filterable: false,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams<UnmappedProduct>) => (
      <button
        className="text-indigo"
        title="Create New Product Mapping"
        onClick={(e) => {
          e.preventDefault();
          if (openModal) openModal(params.row);
        }}>
        <div className="flex items-center text-small">
          <Icon
            type="plus"
            className="mr-1"
          />
          New Product Mapping
        </div>
      </button>
    )
  }
];
